module.exports = __webpack_public_path__ + "assets/img/government1-2.b4b1e6a5.png";